import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=eed6861c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=eed6861c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed6861c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eed6861c')) {
      api.createRecord('eed6861c', component.options)
    } else {
      api.reload('eed6861c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=eed6861c&scoped=true&", function () {
      api.rerender('eed6861c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23pgMmZkhNmzn/JS/comp/PopupBox.vue"
export default component.exports